// extracted by css-extract-rspack-plugin
var _1 = "Notification-m_contents-jxs2RXb5";
var _2 = "Notification-m_details-uYLkpmEf";
var _3 = "Notification-m_error-yFdDh9sb";
var _4 = "Notification-m_icon-JeQ70ULr";
var _5 = "Notification-m_info-cjbNldwa";
var _6 = "Notification-m_inner-GiS2sGZc";
var _7 = "Notification-m_notification-OhRc8Oi1";
var _8 = "Notification-m_progress-qN5LZu82";
var _9 = "Notification-m_success-KuyW9Z58";
var _a = "Notification-m_timer-v5jl4inX";
var _b = "Notification-m_title-KkCE1zAR";
var _c = "Notification-m_trailer-C1kp0mHI";
var _d = "Notification-m_warning-oJ9iDQkN";
export { _1 as "contents", _2 as "details", _3 as "error", _4 as "icon", _5 as "info", _6 as "inner", _7 as "notification", _8 as "progress", _9 as "success", _a as "timer", _b as "title", _c as "trailer", _d as "warning" }
